import { SovosButton, SovosPageLayout } from 'mosaic-react';
import React from 'react';

import LocationMappingTable from './locationMappingTable/LocationMappingTable';
import { useNavigate } from 'react-router-dom';
const LocationMappingsPage: React.FC = () => {
	let navigate = useNavigate();

	const titleBarActions = () => {
		return [
			<SovosButton
				onClick={() => navigate('/location-mappings/new')}
				key='addCustomer'
				className='NewLocationMapping_AddButton'
			>
				Create new
			</SovosButton>,
		];
	};

	return (
		<SovosPageLayout
			pageTitle='Location Mappings'
			titleBarActions={titleBarActions()}
			className='LocationMappings_PageLayout'
		>
			<LocationMappingTable />
		</SovosPageLayout>
	);
};

export default LocationMappingsPage;
